export default __webpack_public_path__ + "static/media/ca-es.e41ce34b.svg";